import { createTheme as t } from "./ghl-ui.es827.js";
import m from "./ghl-ui.es1133.js";
import o from "./ghl-ui.es995.js";
import i from "./ghl-ui.es862.js";
import r from "./ghl-ui.es1080.js";
import a from "./ghl-ui.es1066.js";
const n = t({
  name: "DynamicTags",
  common: m,
  peers: {
    Input: o,
    Button: i,
    Tag: r,
    Space: a
  },
  self() {
    return {
      inputWidth: "64px"
    };
  }
}), f = n;
export {
  f as default
};
